import { render } from "./pieChart.vue?vue&type=template&id=5e44c14f"
import script from "./pieChart.vue?vue&type=script&lang=js"
export * from "./pieChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__